import * as React from "react";
import styled, { css } from "styled-components";
import { mobile } from "../../../../../ui/_themes/constants";
import {
  getBackgroundColor,
  getColor
} from "../../../../../ui/_themes/helpers";
import {
  iPadLandscapeOnly,
  iPadPortraitOnly
} from "../../../../../ui/_utils/styleUtils";
import { IAutoplayButton } from "../../../../../ui/AutoplayButton";
import { CombinedSpinButton } from "../../../../../ui/CombinedSpinButton";
import { StyledAutoplayButton } from "../../../../../ui/CombinedSpinButton/components/AutoplayButton";
import { KeypadButton } from "../../../../../ui/KeypadButton";
import { IKeypadButton } from "../../../../../ui/KeypadButton/index";

interface IKeypadButtonExtended extends IKeypadButton {
  visible?: boolean;
}

function WithRoundedBackground(WrappedComponent) {
  const Wrapper = styled.div`
    display: flex;
    flex: 1 0 auto;
    justify-content: center;
    align-items: center;
  `;

  const RoundedBackground = styled<IKeypadButtonExtended, "div">("div")`
    visibility: ${({ visible = true }) => (visible ? "visible" : "hidden")};
    width: 2.9em;
    height: 2.9em;
    background: ${getBackgroundColor("keypadIcons", "keypad.icons")};
    border-radius: 100%;

    @media (orientation: landscape) {
      width: 2.2em;
      height: 2.2em;
    }
  `;

  class RoundedWrappedComponent extends React.PureComponent<
    IKeypadButtonExtended
  > {
    public render() {
      return (
        <Wrapper>
          <RoundedBackground visible={this.props.visible}>
            <WrappedComponent {...this.props} />
          </RoundedBackground>
        </Wrapper>
      );
    }
  }

  return styled(RoundedWrappedComponent)``;
}

export const KeypadButtonContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 20%;
  min-height: 2.9em;
  min-width: 2.9em;

  @media (orientation: landscape) {
    min-width: 2.2em;
    min-height: 2.2em;
  }

  ${iPadPortraitOnly(css`
    padding: 0 0.3em;
  `)}

  ${iPadLandscapeOnly(css`
    padding: 0.3em 0;
  `)}
`;

const KeypadButtonWrapper = styled<IKeypadButtonExtended>(KeypadButton)`
  color: ${getColor("keypadIcons", "keypad.icons")};
  pointer-events: ${props => (props.disabled ? "none" : "all")};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 100ms ease;
  visibility: ${({ visible = true }) => (visible ? "visible" : "hidden")};
  flex-grow: 1;

  @media (orientation: landscape) {
    svg {
      width: ${mobile.landscape.sidePanel.icon.width};
      height: ${mobile.landscape.sidePanel.icon.height};
    }
  }

  @media (orientation: portrait) {
    svg {
      width: 2.1em;
      height: 2.1em;
    }
  }
`;

export const StyledKeypadButton = WithRoundedBackground(KeypadButtonWrapper);

export const StyledCombinedSpinButton = styled(CombinedSpinButton)`
  pointer-events: none;
  position: absolute;

  @media (orientation: landscape) {
    width: 4em;
    height: 4em;
    top: 50%;
    right: 30%;
    transform: translateY(-50%);
  }

  @media (orientation: portrait) {
    width: 5em;
    height: 5em;
    left: 50%;
    bottom: 6.7em;
    transform: translateX(-50%);
  }

  &${StyledAutoplayButton}::before {
    font-size: ${(props: IAutoplayButton) =>
      props.autoplayRoundsLeft > 999 ? "0.8em" : mobile.fontSize.s};
  }
`;
